/* global kakao */
export enum VisitStatus {
  'intact',
  'visited',
  'met',
  'noVisit',
}

export interface VisitStats {
  visits: number;
  mets: number;
  total: number;
}

export interface Household {
  id: number;
  name: string;
  status: VisitStatus;
  isLock?: boolean;
  gateId: number;
}

export interface Gate {
  id: number;
  name: string;
  households?: Array<Household>;
  buildingId: number;
}

export interface Building {
  id: number;
  name: string;
  address: string;
  gates?: Gate[];
  layerId: number;
}

export interface KakaoAddress {
  address: kakao.maps.services.Address;
  road_address: kakao.maps.services.RoadAaddress | null;
}

export interface LatLng {
  lat: number;
  lng: number;
}

export interface Layer {
  id: number;
  level: number;
  name: string;
  description: string;
  polygonPath: LatLng[];
  centroid: LatLng;
  parentName: string;
  buildings?: Building[];
}
